import { flattenMoves } from '@core/models/entities/implementations/route-action-occupants';
import {
  UserRouteActionV1Model,
  formatCapacityValue
} from '@core/models/entities/implementations/user-route-action-v1';
import { isGreater } from '@core/utils/quantity-utils';

/**
 * What the job moves at the stop, per capacity, as "0.8 t": what it unloads there, or else what
 * it loads; `null` when it moves no capacity.
 */
export function jobQuantity(action: UserRouteActionV1Model, jobUid: string): string | null {
  const moves = flattenMoves(action.movements ?? []).filter(
    (move) =>
      move.job_uid === jobUid &&
      move.axis === 'capacity' &&
      !!move.capacity_resource_uid &&
      isGreater(move.quantity, 0)
  );
  const unloads = moves.filter((move) => move.kind === 'unload');
  const counted =
    unloads.length > 0 ? unloads : moves.filter((move) => move.kind === 'load');
  const byCapacity = new Map<string, number>();
  for (const move of counted) {
    const uid = move.capacity_resource_uid!;
    byCapacity.set(uid, (byCapacity.get(uid) ?? 0) + move.quantity);
  }
  if (byCapacity.size === 0) return null;
  return [...byCapacity]
    .map(([uid, quantity]) => `${formatCapacityValue(quantity)} ${uid}`)
    .join(', ');
}
